import { MESSAGE_TYPE } from '../constants.js';

const isValidEvent = (event, allowedOrigin) => (event.origin === allowedOrigin || allowedOrigin === "*") && Boolean(event.data) && event.data.type === MESSAGE_TYPE;

export { isValidEvent };
